var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("\n        Visão Geral\n    ")]),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.solicitar()}}},[_vm._v("\n        Solicitar\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }